module.exports = __webpack_public_path__ + "static/media/galeria-fotos-7.16c41b18.png";